var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.$store.getters.agent && !_vm.$store.getters.isMobile)?_c('div',{staticClass:"home flex-row"}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }